<template>
  <div class="text-xs font-medium uppercase step-breadcrumb lg:w-9/12 visuallyhidden">
    <div
      v-for="segment in quizStore.quiz.segments"
      :key="segment.id"
      class="step"
      :class="{
        active: segment.id == quizStore.currentSegmentId,
        done:
          quizStore.answers.filter((answer) => answer.segment_id == segment.id)
            .length > 0 &&
          quizStore.answers.filter((answer) => answer.segment_id == segment.id)
            .length ===
            quizStore.quiz.segments.find((s) => s.id == segment.id).questions
              .length,
      }"
    >
      <em
        :style="{
          width:
            (quizStore.answers.filter(
              (answer) => answer.segment_id == segment.id
            ).length /
              quizStore.quiz.segments.find((s) => s.id == segment.id).questions
                .length) *
              100 +
            '%',
        }"
        >&nbsp;</em
      >
      <span>
        {{ segment.title }}
        <i v-if="isDev" class="ml-2">
          {{ quizStore.getSegmentScore(segment.id).score }} /
          {{ quizStore.getSegmentScore(segment.id).max }}
        </i>
      </span>
    </div>
  </div>
</template>
<script setup>
import { useQuizStore } from "@/stores/quiz";
const quizStore = useQuizStore();
const isDev = document.location.hostname.match(/(localhost|monudi.test)/);
</script>
